// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-Icon_cls1__BHQpU","cls2":"VeloTable-Icon_cls2__BZY6I VeloTable-Icon_cls1__BHQpU"};